<button
  mat-stroked-button
  color="primary"
  class="rounded-full"
  [matMenuTriggerFor]="menu">
  <i class="fa-regular fa-plus mr-2"></i>
  {{ 'shared:create' | translate }}
</button>
<mat-menu #menu="matMenu" xPosition="before">
  <!-- Student payment -->
  <button
    mat-menu-item
    class="font-medium mb-2"
    *ngIf="featureFlags$ | async as flags"
    (click)="
      flags['ew2016RevisitStudentPayment']
        ? MDS.studentPayment()
        : MDS.requestMoney()
    ">
    <mat-icon
      class="mr-2 ml-0 icon-size-17 fa-regular fa-arrow-circle-down text-[#27ae60]"></mat-icon>
    <div class="grid">
      <span class="text-sm">
        {{ 'transactions:typeINCOME' | translate }}
      </span>
      <span class="text-[11px] text-[#64748b]">
        {{ 'transactions:typeINCOMESubtitle' | translate }}
      </span>
    </div>
  </button>

  <!-- Corporate payment -->
  <button mat-menu-item class="font-medium mb-2" (click)="MDS.invoiceFunds()">
    <mat-icon
      class="mr-2 ml-0 icon-size-17 fa-regular fa-arrow-circle-down text-[#2097f6]"></mat-icon>
    <div class="grid">
      <span class="text-sm">
        {{ 'transactions:typeINVOICE_FUNDS' | translate }}
      </span>
      <span class="text-[11px] text-[#64748b]">
        {{ 'transactions:typeINVOICE_FUNDSSubtitle' | translate }}
      </span>
    </div>
  </button>

  <!-- Commission -->
  <button
    mat-menu-item
    class="font-medium mb-2"
    *ngIf="(featureFlags$ | async)?.['ew2729CommissionPaymentRequest']"
    (click)="MDS.commissions()">
    <mat-icon
      class="mr-2 ml-0 icon-size-17 fa-regular fa-arrow-circle-right text-[#27ae60]"></mat-icon>
    <div class="grid">
      <span class="text-sm">
        {{ 'transactions:typeCOMISSIONS' | translate }}
      </span>
      <span class="text-[11px] text-[#64748b]">
        {{ 'transactions:typeCOMISSIONSSubtitle' | translate }}
      </span>
    </div>
  </button>

  <!-- Convert Funds -->
  <button mat-menu-item class="font-medium mb-2" (click)="MDS.convertFunds()">
    <mat-icon
      class="mr-2 ml-0 icon-size-17 fa-regular fa-arrow-circle-left text-[#5c5c5c]"></mat-icon>
    <div class="grid">
      <span class="text-sm">
        {{ 'transactions:typeCONVERT_FUNDS' | translate }}
      </span>
      <span class="text-[11px] text-[#64748b]">
        {{ 'transactions:typeCONVERT_FUNDSSubtitle' | translate }}
      </span>
    </div>
  </button>

  <!-- Payout -->
  <button
    mat-menu-item
    class="font-medium mb-2"
    (click)="MDS.withdrawMoney({ type: 'PAYOUT' })">
    <mat-icon
      class="mr-2 ml-0 icon-size-17 fa-regular fa-arrow-circle-up text-[#760000]"></mat-icon>
    <div class="grid">
      <span class="text-sm">
        {{ 'transactions:typePAYOUT' | translate }}
      </span>
      <span class="text-[11px] text-[#64748b]">
        {{ 'transactions:typePAYOUTSubtitle' | translate }}
      </span>
    </div>
  </button>

  <!-- Withdrawal -->
  <button
    mat-menu-item
    class="font-medium mb-2"
    (click)="MDS.withdrawMoney({ type: 'WITHDRAWAL' })">
    <mat-icon
      class="mr-2 ml-0 icon-size-17 fa-regular fa-arrow-circle-up text-[#ffb536]"></mat-icon>
    <div class="grid">
      <span class="text-sm">
        {{ 'transactions:typeWITHDRAWAL' | translate }}
      </span>
      <span class="text-[11px] text-[#64748b]">
        {{ 'transactions:typeWITHDRAWALSubtitle' | translate }}
      </span>
    </div>
  </button>
</mat-menu>
